const messages = {
    fields: {
        first_name: 'Prénom',
        last_name: 'Nom de famille',
        address: 'Adresse',
        postcode: 'Code postal',
        city: 'Ville',
        phone: 'Numéro de téléphone',
        house_number: 'numéro',
        password: 'Password',
    },
    customPages: {
        mainCategory: 'catégories principales',
    },
    validations: {
        required: '{field} obligatoire',
        invalid: '{field} erroné',
    },
    blockCart: {
        addToCart: 'Ajouter au panier',
        addedToCartTitle: 'Ajouté ̀ votre panier',
        proceedToCheckout: 'Panier',
        productTotal: 'Total',
        showAllProducts: 'Afficher tous les produits',
        cartShipping: 'Frais de port',
        cartTotal: 'Total',
        close: 'Fermer',
        addedToCartChoiceTitle: 'Votre choix:',
        noItemSelected: 'Aucune variante sélectionnée !',
    },
    myAccount: {
        titlePersonalInformation: 'Mes informations',
        adjustData: 'Modifier mes informations',
        setNewPassword: 'Mot de passe oublié?',
        phoneNumberMessage: 'En cas de livraison',
        houseNumber: 'Nr',
        optional: 'Facultatif',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        email: 'E-mail',
        titleOrderHistory: 'Mes commandes',
        logout: 'Se déconnecter',
        loading: 'Chargement...',
        yourCart: 'Mon panier',
        address2: "Complément d'adresse",
        addAddress: 'Ajouter une adresse',
        defaultAddress: 'Adresse par défaut',
        setAsDefaultAddress: 'Adresse par défaut',
        adjust: 'Modifier',
        name: 'Nom',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        address: 'Adresse',
        zipcode: 'Code postal',
        residence: 'Ville',
        country: 'Pays',
        phone: 'Téléphone',
        phoneNumber: 'Numéro de téléphone',
        copyAddress: "Copier l'adresse",
        delete: 'Supprimer',
        errorMessage: 'Nous sommes désolés, une erreur a été trouvée',
        cancel: 'Annuler',
        save: 'Poursuivre',
        packaging: 'Conditionnement',
        unitPrice: "Prix à l'unité",
        price: 'prix',
        totalPriceProducts: 'Prix total des produits commandés',
        total: 'Total',
        freeOfCharge: 'Gratuit',
        taxIncl: 'taxe incl.',
        continueToOrder: 'Accéder au paiement',
        easyReorder: 'Recommandez facilement!',
        easyReorderMessage: 'Ajoutez les produits commandés précédement et accédez au paiement',
        emtpyOrderMessage:
            'Quand vous avez passé une commande, vous trouverez toutes les informations relatives à celle-ci ici  (facture , statut, etc...). Vous pouvez aussi facilement commander de nouveau vos précédentes commandes.',
        emtpyOrderMessage2: 'Cliquez',
        emtpyOrderMessage3: 'ici',
        emtpyOrderMessage4: "Aller sur la page d'accueil.",
        reorder: 'Recommander',
        products: 'Produit(s)',
        totalShipmentCost: 'Prix total des frais de port',
        shipmentCost: 'Frais de port',
        status: 'Statut',
        detailsInvoice: 'Détails & Facture',
        downloadInvoice: 'Télécharger ma facture',
        shippedBy: 'Envoyé par',
        paymentMethod: 'Mode de paiement',
        deleteAddressModalText: 'Voulez-vous vraiment supprimer cette adresse?',
        deleteAddressModalLoaderText: 'Supprimer?',
        errorModalText: "Toutes nos excuses, quelque chose s'est mal passé",
        errorModalText2: 'Merci de réessayer plus tard',
        appModalTitle: 'Brekz - Animalerie en ligne - Application',
        appModalText:
            'Op elk moment alles voor uw huisdier kunnen bestellen? Vanaf nu kunt u dit gemakkelijk doen via de Brekz App.\n' +
            'Duizenden producten zoals voer, lekkere snacks en leuke speeltjes op één plek gemakkelijk bestellen.',
        appModalText2: 'Retrouvez notre application sur Play Store et App Store',
        appModalListTitle: 'Avantages',
        appModalListItem: '- Avoir votre animalerie à portée de main',
        appModalListItem1: '- Recommander rapidement et facilement',
        appModalListItem2: '- Notifications utiles sur votre commande et nos',
        appModalListItem3: '- Définissez le nombre \\/ et le type de notifications que vous souhaitez recevoir',
        appModalListItemLink: 'Offres',
        reorderModalSorry: 'Malheureusement, ce produit n’est pas disponible',
        reorderModalOutOfStock: 'Non disponible',
        reorderModalPackaging: "Ce produit n'est plus disponible",
        reorderModalSkip: 'Passer ce produit',
        reorderModalAlternativesInStock: 'Produits alternatifs disponibles',
        reorderModalQuantity: 'quantité',
        pricePerUnit: 'Prix unitaire',
        addProduct: 'ajouter',
        bundleDiscount: 'Avantage lot',
        discount: 'Economisez',
        reorderModalOrderAlternative: 'Commander l’un des produit équivalent',
        saveConfirmationModalTitle: 'Vos données ont été sauvegardées',
        minimumPurchaseMessage:
            'Le minimum d’achat est de {amount} (sans les frais de port). Ajoutez un ou plusieurs produits à votre panier pour continuer.',
        trackAndTraceText: "Suivre votre commande (disponible après l'envoi de votre colis)",
        noAlternativeProducts: "Malheureusement, nous ne proposons pas d'autre format",
        addressDescription:
            'Voici un aperçu de votre adresse. Vous pouvez également les modifier ces informations ici.\n',
        titleMyOrders: 'Mes commandes',
        orderDescription: 'Consulter le statut de votre commande, votre facture ou simplement commander à nouveau\n',
        orderDescriptionShort: 'Consulter le statut de votre commande\n',
        addresses: 'Mes adresses',
        okay: 'Ok',
        errorFirstName: 'Veuillez vérifier votre prénom',
        errorLastName: 'Veuillez vérifier votre nom de famille',
        errorEmail: 'Veuillez vérifier votre adresse mail',
        errorPhone: 'Veuillez vérifier votre numéro de téléphone',
        errorAddress: 'Veuillez vérifier le numéro et nom de la rue',
        errorAddress2: 'Veuillez vérifier le numéro et nom de la rue',
        errorZipcode: 'Code postal non valide',
        errorCity: 'Veuillez vérifier votre lieu de résidence',
        errorPassword: 'Mot de passe trop court ou inexistant',
        eraseWarning: "Vous êtes sur le point d\\'effacer toutes les données que vous avez saisies !",
        eraseConfirmation: 'Etes-vous sûr de vouloir les effacer?',
        amount: 'Quantité',
        orderDate: 'Date de commande',
        trackAndTrace: 'suivre votre colis',
        close: 'Fermer',
        toCart: 'Consulter mon panier',
        productsInCart: 'Les produits ont été ajoutés à votre panier',
        orderInCart: 'Votre commande a été  ajoutée à votre panier',
        productsInColumn:
            "Vous pouvez trouver les produits dans la colonne de droite sur cette page, ou cliquer sur l'icône du panier en haut à droite de la page",
        orderStatus: 'Statut de votre commande',
        orderProcess: 'Dans la plupart des cas, votre commande passe par les étapes suivantes :',
        paymentWaiting: 'Paiement et attente',
        paymentReceived: 'Paiement reçu',
        orderCollected: 'Commande en cours de préparation',
        orderSent: 'Votre commande a été expédiée',
        followOrder: 'Vous pouvez désormais ',
        followOrderEnd: ' grâce au système de suivi et de localisation.',
        multiplePackages: 'N.B. : la commande comprend plusieurs colis',
        trackAndTraceActiveTime: 'Note : le lien peut prendre un certain temps avant de devenir actif',
        delivered: 'Reçu',
        password: 'Mot de passe',
        didYouMean: 'Vouliez-vous dire',
        apply: 'Appliquer',
        bundle: 'Lot',
        bundlePriceWas: 'Avant',
        saving: 'Économisez',
    },
    checkout: {
        between: '',
        and: 'a',
        days: "jours ouvrés",
        delivery: 'Livraison',
        countdownMessage1: 'Commandez avant',
        countdownMessage2: 'pour une livraison rapide',
        newCard: 'Utiliser une nouvelle la carte de crédit',
        creditCard: 'La carte de crédit',
        addNewCard: 'Ajouter une nouvelle la carte de crédit',
        passwordMessage: '5 caractères minimum',
        loading: 'Chargement...',
        lastStep: 'Dernière étape',
        savedCard: 'Utiliser la carte enregistrée',
        cardNumber: 'Numéro de carte',
        otherCard: 'Utiliser une autre carte',
        expireDate: "Date d'expiration",
        errorCard: "Cette carte n'est pas valide ou n'est pas prise en charge",
        errorName: 'Nom actuel invalide',
        errorDate: "Date d'expiration actuelle invalide ou expirée",
        errorCVV: 'CVV actuel invalide',
        cardExpired: 'Cette carte a expiré dans notre système. Veuillez à nouveau enregistrer votre carte.',
        saveCard: 'Enregistrer la carte de crédit',
        nextTime: 'pour la prochaine fois',
        order: 'Commander',
        back: 'Retour aux options de paiement',
        addressEdit: 'Modifier adresse',
        paymentSucces: 'Votre paiement a bien été reçu',
        backToOrderhistory: 'Vous serez redirigé vers le récapitulatif de votre commande dans quelques secondes',
        bancontactNotAvailable: "Bancontact n'est pas disponible",
        allData: 'Toutes vos données sont',
        secured: 'sécurisé',
        almostDone: 'Presque terminée',
        banContactNotAvailable: 'Bancontact is niet beschiktbaar op',
        payWith: 'Reken af met uw',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Andere Bancontact gebruiken',
        useNewBancontact: 'Nieuwe Bancontact gebruiken',
        addNewBancontact: 'Nieuwe Bancontact toevoegen',
        payWithBancontactApp: 'Payer avec l\'application Bancontact',
        openBancontactApp: 'Ouvrez votre application Bancontact et scannez le code pour finaliser votre paiement en toute sécurité.',
        noBancontactApp: 'Vous n\'avez pas l\'application ? Choisissez une autre méthode de paiement proposée à droite.',
        mistercacheSave: 'Enregistrer Bancontact',
        cardHolderNamePlaceholder: 'M. DUPONT',
        newAccount: 'Vos informations personnelles',
        cancel: 'Annuler',
        taxIncl: 'taxe incl.',
        total: 'Total',
        name: 'Nom',
        close: 'Sluiten',
        errorText: "Toutes nos excuses, quelque chose s'est mal passé",
        errorModalText: "Toutes nos excuses, quelque chose s'est mal passé",
        errorModalText2: 'Merci de réessayer plus tard',
        rememberAddressHeaderTitle: 'Gagnez du temps lors de votre prochain achat',
        rememberAddressSwitchLabel: 'Utilisez cette adresse et ce mode de paiement pour vos futures commandes.',
        paymentSecurityText: 'Toutes vos données sont',
        paymentSecurityTextBold: 'sécurisées',
        paymentCardHeaderTitle: 'Options de paiement',
        addressCardHeaderTitle: 'Adresse de livraison',
        invoiceAddress: 'Adresse de la facture',
        editAddress: 'Ajuster',
        addNewAddress: 'Ajoutez une nouvelle adresse',
        addNewInvoiceAddress: 'Ajouter une nouvelle adresse de facturation',
        addressMatchesInvoiceAddress: "L'adresse de facturation est la même que l'adresse de livraison",
        addressMatchesNotInvoiceAddress: "L'adresse de facturation n'est pas la même que l'adresse de livraison.",
        // checkout progressbar
        progressbarLogIn: 'Connexion',
        progressbarPaymentOption: 'Mode de paiement',
        progressbarPayment: 'Paiement',
        progressbarDone: 'Prêt!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage:
                'Vous avez décidé de payer avec <strong>Klarna</strong>. Votre numéro de téléphone est obligatoire.',
            phoneNumberInputField: 'Saisissez ici votre numéro de téléphone',
            otherPaymentMethod: 'Other payment method',
        },
        validationErrors: {
            noPaymentMethodSelected: "Vous n'avez pas encore choisi un moyen de paiement",
            noAddressSelected: "Vous n'avez pas encore choisi une adresse de livraison et/ou de facturation.",
            paymentMethodRequiresPhoneNumber:
                "Votre numéro de téléphone ne figure pas dans vos coordonnées. Merci de l'ajouter pour payer avec Klarna.",
            termsOfServices: 'U heeft de Algemene voorwaarden niet geaccepteerd',
            noDeliveryOnThisAddress:
                'Malheureusement, nous ne livrons pas au code postal que vous avez indiqué. Lors de la commande, vous pouvez choisir de faire livrer le colis à un autre code postal.',
        },
        processWaiting: {
            title: 'Le paiement est en cours',
            description: 'patientez quelques instants avant la fin de l’opération',
        },
    },
    address: {
        placeholderFirstname: 'Jan',
        placeholderLastname: 'Janssen',
        placeholderAddress: '123 Rue de Paris',
        placeholderAddress2: 'Société, lieu-dit, bât., appart., étage, BP,...',
        placeholderZipcode: '12345',
        placeholderCity: 'Paris',
        placeholderPhone: '0612345678',
        noShipping:
            "Le code postal que vous avez choisi entraîne malheureusement des frais d'expédition supplémentaires. Pour éviter ces frais, vous pouvez faire livrer le colis ailleurs.",
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Tenez-moi au courant',
        modalMessage: 'Vous recevrez un email dès que ce produit sera de nouveau disponible.',
        modalSubmitButton: 'Tenez-moi au courant',
        email: 'E-mail',
        placeholderEmail: 'visualiser@email.com',
        noAbuse: 'Votre adresse email ne sera pas utilisée ̀ d’autres fins.',
        alreadySignedUp: 'Vous vous êtes déj̀ inscrit ̀ une alerte e-mail pour ce produit',
        invalidEmail: 'Adresse e-mail invalide',
        genericError: "Une erreur s'est produite",
    },
    orderConfirmation: {
        modalTitle: 'Vous souhaitez pouvoir suivre votre commande?',
        modalMessage:
            "Vous avez commandé en tant qu'invité. Si vous ajoutez un mot de passe, vous pourrez consulter le statut de votre commande en accédant ̀ votre compte personnel.",
        enterPassword: 'Ajouter un mot de passe',
        minimumWarning: 'Minimum 5 caractères',
        passwordTooShort: 'Le mot de passe saisi est trop court',
        somethingWentWrong: "Une erreur générale s'est produite",
    },
    unsubPage: {
        emailQuestion: 'Pour quelle adresse électronique ?',
        emailKnown: 'Adresse électronique de votre compte: ',
        emailadres: 'Adresse électronique:',
        changeEmailSettings: 'Modifier vos préférences de notifications par e-mail ',
        iWant: 'Je souhaite',
        iWant2: 'Je',
        keepProfiting: 'continuer ̀ bénéficier  ',
        ofTheBenefitMail: 'des e-mails promotionnels',
        sendMe: 'Envoyez-moi des ',
        onesEvery2Weeks: 'offres exclusives et toutes les bonnes affaires ',
        exclusiveOffersAndTheBestDiscounts: 'toutes les deux semaines',
        onetimeAMonth: '1 fois par mois ',
        wellEnoughButDontMiss: 'suffit, mais je ne veux manquer aucun avantage',
        noBenefit: 'Je ne souhaite plus recevoir d’offres promotionnelles',
        writeMeOut: ', je me désinscris',
        benefitMail: 'E-mail promotionnel  ',
        birthdayMail: "E-mail d'anniversaire",
        tipsAndAdvice: 'Astuces et conseils',
        personalDiscount: 'Remises personnelles',
        productReviewAndReviews: 'Évaluation et avis sur le produit\n',
        stillReceiveUpdatesAboutDelivery:
            'Vous continuerez bien sûr ̀ recevoir les messages liés ̀ vos transactions et ̀ vos livraisons.',
        feedBackAndTips: 'Avez-vous des conseils ou des commentaires ̀ nous soumettre?',
        cancel: 'Annuler',
        benefitDogCat: 'Ajouter un avantage pour chien/chat ?',
        iWantBenefitFor: 'Je voudrais recevoir des avantages pour',
        dogs: 'Chien',
        cats: 'Chat',
        dogsAncCats: 'Chien et Chat',
        no: 'ne veux',
        receiveMoreBenefitFor: "plus recevoir d'avantages pour chien/chat",
        giveMe: 'Envoyez-moi ',
        allBenefit: 'toutes les offres',
        average2MailsAWeek: '(2 e-mails promotionnels par semaine en moyenne)',
        oneTime2Weeks: '1 fois toutes les deux semaines',
        save: 'Valider',
        received: '',
        selectVariant: 'Choisir la variante',
        YouAreSuccessfullyUnsubscribedFor: 'Vous avez été désabonné(e) avec succès de :',
        checkYourEmail: 'Vérifiez votre adresse e-mail',
        noOptionSelected: 'Veuillez sélectionner une option',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'par client',
        },
        searchButton: 'Chercher',
        searchPlaceholder: 'Chercher le produit',
        searchBarInputPlaceholder: 'Chercher le produit',
        searchBarInputPlaceholderApp: '6000+ Producte',
        noResultsContentTitleCategory: "Malheureusement, aucun produit n'a été trouvé avec les filtres sélectionnés",
        noResultsContentTitle:
            'Nous <b>n\'avons trouvé</b> aucun résultat pour <span class="algolia-listing-no-results__content-title--brand">“{query}“</span>',
        noResultsContentListTitle: 'Ce que vous pouvez faire :',
        noResultsContentListItemOne: "Vérifiez l'orthographe de votre recherche",
        noResultsContentListItemOneCategory: 'Supprimer un ou plusieurs filtres',
        noResultsContentListItemTwo:
            'Vous cherchiez une marque ? Malheureusement, nous ne disposons pas (encore) de cette marque dans notre gamme',
        noResultsContentListItemTwoCategory: 'Cliquez sur "Effacer tout" pour lancer une nouvelle recherche.',
        noResultsContentListItemThree: 'Essayez de faire une autre recherche',
        noResultsWithQuery: 'Aucune suggestion n\'a été trouvée pour <b>"{query}"</b>',
        searchHistoryTitle: 'Recherche récente',
        searchResultsHeader: '<b>{resultCount}</b> resultaten voor <b>"{query}"</b> in alle artikelen.',
        searchResultsHeaderSubtitle: 'Verfijn uw resultaten met onderstaande filters.',
        searchResultsTitle: 'Suggestions de recherche',
        popularProductsTitle: 'Favoris',
        popularCategoriesTitle: 'Catégories les plus populaires',
        queryMirrorTitle: 'Votre recherche',
        resultsHitsProducts: 'Produits',
        resultsHitsDelete: 'Tout effacer',
        resultsHitsFilter: 'Filtrer',
        resultsHitsFilterNote: 'Utilisez les filtres pour trouver plus rapidement ce que vous cherchez',
        fiterPanelMobileHeaderTitle: 'Filtrer',
        fiterPanelMobileHeaderSubtext: 'Utilisez les filtres pour trouver plus rapidement ce que vous cherchez',
        fiterPanelMobileDeleteFilters: 'Tout effacer',
        fiterPanelMobileFilteredProductAmount: 'Produits',
        fiterPanelMobileSaveSelection: 'Enregistrer la sélection',
        fiterPanelMobileFooterTextPartOne: 'Filtrer',
        fiterPanelMobileFooterTextPartTwo: 'résultats',
        hitItemFromLabel: '̀ partir de',
        hitItemViewProduct: 'Voir le produit',
        refinementListViewMore: 'Plus...',
        refinementListViewLess: 'moins...',
        refinementListRangeBoxInbetween: '>',
        unAvailableNotePartOne: 'De nouveau disponible <br /> le',
        unAvailableNotePartTwo: ' ',
        filters: {
            priceReduction: {
                on: 'Oui',
                off: 'Non',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts : 'Produits similaires',
        recommendedProductsSubtitle : 'Différents, mais aussi excellents',
        boughtTogether : 'Souvent acheté ensemble',
        boughtTogetherSubtitle : 'Prêt en une seule fois!'
    },
    mobileMenu: {
        makeYourChoice: 'Faites votre choix',
    },
    combinationPromotion: {
        op: 'Stock limité',
        bonus: 'Bonusbag',
        twoPlusOneFree: '2 + 1 Gratuit',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Les mots de passe ne sont pas identiques',
        passwordForgot: 'Mot de passe oublié ? ',
        createNewPassword: 'Créer un nouveau mot de passe ',
        description:
            "Veuillez saisir l'adresse mail de votre compte. Nous enverrons ̀ cette adresse mail un lien qui vous permettra de définir un nouveau mot de passe.",
        email: 'Adresse mail',
        note: 'Cela peut prendre un certain temps avant que vous ne receviez le lien. Attendez au moins 4 minutes avant de demander à nouveau un lien. Cela vous évite de recevoir un lien qui ne fonctionne pas. ',
        setNewPassword: 'Définir un nouveau mot de passe',
        chooseNewPassword: 'Choisissez votre nouveau mot de passe',
        newPassword: 'Nouveau mot de passe',
        reenterPassword: 'Entrez ̀ nouveau votre nouveau mot de passe',
        passwordsDontMatch: "Le mot de passe dans le champ 2 n'est pas identique au champ 1",
        passwordsDontMatchError: 'Les mots de passe ne sont pas identiques',
        submit: 'Confirmation',
    },
};
export default messages;
